var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtherIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6 4C1.6 2.675 2.675 1.6 4 1.6C5.325 1.6 6.4 2.675 6.4 4C6.4 5.0675 5.7025 5.9725 4.7375 6.285C4.0275 6.515 3.2 7.1675 3.2 8.2V8.8C3.2 9.2425 3.5575 9.6 4 9.6C4.4425 9.6 4.8 9.2425 4.8 8.8V8.2C4.8 8.1575 4.815 8.0975 4.8875 8.0175C4.9625 7.935 5.085 7.855 5.23 7.8075C6.8375 7.29 8 5.7825 8 4C8 1.79 6.21 0 4 0C1.79 0 0 1.79 0 4C0 4.4425 0.3575 4.8 0.8 4.8C1.2425 4.8 1.6 4.4425 1.6 4ZM4 12.8C4.5525 12.8 5 12.3525 5 11.8C5 11.2475 4.5525 10.8 4 10.8C3.4475 10.8 3 11.2475 3 11.8C3 12.3525 3.4475 12.8 4 12.8Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherIcon);
export default __webpack_public_path__ + "static/media/otherIcon.f33896782d686ba9467143caca4e9206.svg";
export { ForwardRef as ReactComponent };